export default __webpack_public_path__ + "static/media/shop7.dfb1e545.jpg";